import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, input, signal, TemplateRef} from '@angular/core';

@Component({
  selector: 'j4-alert',
  templateUrl: './j4-alert.component.html',
  styleUrls: ['./j4-alert.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class J4AlertComponent {
  protected readonly alertClasses = computed(() => ({
    [this.type()]: true,
    'form-addon': this.isFormAddon(),
    'cursor-pointer': this.isExpandable(),
    expanded: this.isExpanded()
  }));
  protected readonly iconText = computed(() => {
    const defaultText = 'i';
    const text = {
      warning: '!',
      error: '!',
      success: '✓',
      info: 'i'
    };

    return text[this.type()] ?? defaultText;
  });
  // If is used bellow an input field in a form
  public isFormAddon = input(false);
  public type = input<'info' | 'warning' | 'success' | 'error'>('info');

  public url = input<string>();
  public urlText = input<string>('See the Article');
  public text = input<string>();
  public isExpandable = input<boolean>(false);
  public contentTemplate = input<TemplateRef<HTMLElement> | null>(null);
  public isExpanded = signal<boolean>(false);

  public toggleExpand(): void {
    if (this.contentTemplate()) {
      this.isExpanded.update(val => !val);
    }
  }
}
